export default { PENDING: 'pending', RESOLVED: 'resolved' };
